import { __rest, __assign } from '../../../../node_modules/tslib/tslib.es6.js';
import React, { useState, useRef, useEffect } from 'react';
import Input from '../Input/input.js';
import '../Input/index.js';
import { DatePickerWrapper } from './style.js';
import DatePickerMenu from './DatePickerMenu.js';
var DatePicker = /*#__PURE__*/React.forwardRef(function (_a, ref) {
  var id = _a.id,
      value = _a.value,
      _b = _a.dateFormat,
      dateFormat = _b === void 0 ? 'MM/DD/YYYY' : _b,
      _c = _a.onDateChange,
      onDateChange = _c === void 0 ? function () {
    return undefined;
  } : _c,
      _d = _a.placeholder,
      placeholder = _d === void 0 ? 'Click to choose a date' : _d,
      _e = _a.placement,
      placement = _e === void 0 ? 'bottom-start' : _e,
      rest = __rest(_a, ["id", "value", "dateFormat", "onDateChange", "placeholder", "placement"]);

  var _f = useState(false),
      menuOpen = _f[0],
      _setMenuOpen = _f[1];

  var _g = useState(value),
      stateValue = _g[0],
      setStateValue = _g[1];

  var inputRef = useRef(null);

  var _changeDate = function changeDate(date) {
    onDateChange(date);

    _setMenuOpen(false);
  };

  useEffect(function () {
    setStateValue(value);
  }, [value]);
  return /*#__PURE__*/React.createElement(DatePickerWrapper, null, /*#__PURE__*/React.createElement(Input, __assign({
    id: id,
    value: stateValue,
    ref: ref || inputRef,
    onChange: function onChange(e) {
      return setStateValue(e.target.value);
    },
    onFocus: function onFocus() {
      return !menuOpen && _setMenuOpen(true);
    },
    onClick: function onClick() {
      return !menuOpen && _setMenuOpen(true);
    },
    placeholder: placeholder
  }, rest)), /*#__PURE__*/React.createElement(DatePickerMenu, {
    setMenuOpen: function setMenuOpen(value) {
      return _setMenuOpen(value);
    },
    changeDate: function changeDate(date) {
      return _changeDate(date);
    },
    value: stateValue,
    menuOpened: menuOpen,
    inputRef: ref || inputRef,
    placement: placement,
    dateFormat: dateFormat
  }));
});
DatePicker.displayName = 'DatePicker';
export default DatePicker;
export { DatePicker };